import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getResultsApi } from '../api/allApi';

export const fetchResults = createAsyncThunk(
    'results/fetchResults',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getResultsApi();
            return data;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to fetch results');
        }
    }
);

const resultsSlice = createSlice({
    name: 'results',
    initialState: {
        data: null,
        fetchLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchResults.pending, (state) => {
                state.fetchLoading = true;
                state.error = null;
            })
            .addCase(fetchResults.fulfilled, (state, action) => {
                state.fetchLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchResults.rejected, (state, action) => {
                state.fetchLoading = false;
                state.error = action.payload;
            });
    },
});

export default resultsSlice.reducer;